<template>
  <status-badge
    :color="color"
    v-if="fullText"
  >
    {{ text }}
  </status-badge>
  <v-icon
    v-else
    :color="color"
    :title="text"
  >{{ icon }}</v-icon>
</template>
<script>
import StatusBadge from './StatusBadge';
import {LocaleUtils} from './../utils/locale-utils';

export default {
  name: 'EmailStatus',
  mixins: [
    LocaleUtils
  ],
  components: {
    StatusBadge
  },
  props: {
    /** @type EmailDto */
    email: {},
    fullText: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      text: null,
      color: null,
      icon: null
    }
  },
  watch: {
    email: {
      immediate: true,
      handler () {
        this.text = this.trans('general.unknown');
        this.color = null;
        this.icon = 'mdi-email-off';
        if (this.email) {
          switch (this.email.status) {
            case 'SENT':
              this.text = this.trans('emailSettings.statusSent');
              this.color = 'success';
              this.icon = 'mdi-email-send';
              break;
            case 'PENDING':
            case 'SENDING':
              this.text = this.trans('emailSettings.statusPending');
              this.color = 'pending';
              this.icon = 'mdi-email-sync';
              break;
            case 'ERROR':
              this.text = this.trans('emailSettings.statusError');
              this.color = 'error';
              this.icon = 'mdi-email-remove';
              break;
            case 'CANCELED':
              this.text = this.trans('emailSettings.statusCanceled');
              this.color = 'warning';
              this.icon = 'mdi-email-remove';
              break;
          }
        }
      }
    }
  }
}
</script>
